enum WaiverMember {
  Self = 'self',
  MySpouse = 'spouse',
  Other = 'other',
}

export default WaiverMember;
